import apiClient from '../../../api/apiClient';
import { ADMIN_REST_API_BASE_URL } from '../../../config';

const REST_API_BASE_URL = ADMIN_REST_API_BASE_URL;

export interface AdminBusinessSummaryDTO {
  id: number;
  businessName: string;
  templateType: string | null;
  status: string;
  objectivesCount: number;
  createdAt: string;
}

export interface AdminAccountDTO {
  // User
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  enabled: boolean;
  createdAt: string;
  // Subscription
  subscriptionState: string | null;
  subscriptionTier: string | null;
  trialEndDate: string | null;
  renewalDate: string | null;
  // Household
  hasHousehold: boolean;
  householdName: string | null;
  householdRole: 'OWNER' | 'PARTNER' | 'VIEWER' | null;
  householdMemberCount: number;
  // Business
  activeBusinessCount: number;
  draftBusinessCount: number;
  businesses: AdminBusinessSummaryDTO[] | null;
}

export const getAccounts = (page = 0, size = 20, search = '') =>
  apiClient.get<{ content: AdminAccountDTO[]; totalElements: number }>(
    `${REST_API_BASE_URL}/accounts?page=${page}&size=${size}&search=${encodeURIComponent(search)}`,
  );

export const getAccountDetail = (userId: number) =>
  apiClient.get<AdminAccountDTO>(`${REST_API_BASE_URL}/accounts/${userId}`);
